import React from 'react';
import PropTypes from 'prop-types';
import {
  TiArrowSortedDown,
  TiArrowSortedUp,
  TiArrowUnsorted,
} from 'react-icons/ti';

const TableHeadCell = ({
  id,
  label,
  isSort,
  isSorted,
  onSort,
  order,
  className,
}) => {
  const classNames =
    'd-flex align-items-center cell-item ' +
    (isSort ? 'cursor-pointer' : '') +
    (isSorted ? ' text-primary' : '');
  return (
    <div className={classNames} onClick={() => onSort(id)}>
      {label}
      {isSort && (
        <>
          {isSorted ? (
            order ? (
              <TiArrowSortedUp className="m-1" size={12} />
            ) : (
              <TiArrowSortedDown className="m-1" size={12} />
            )
          ) : (
            <TiArrowUnsorted className="m-1" size={12} />
          )}
        </>
      )}
    </div>
  );
};

TableHeadCell.defaultProps = {
  isSort: true,
  isSorted: false,
  onSort: () => {},
};

TableHeadCell.propTypes = {
  // id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
};

export default React.memo(TableHeadCell);
